import { Record } from 'immutable';
const AuthorRecord = Record({
  authorName: undefined,
  id: undefined
});
export default AuthorRecord;